import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { UtilsService } from '../utils/utils.service';

@Injectable({
  providedIn: 'root'
})
export class CallerReportService {

	constructor(
		private http: HttpClient,
		private utils: UtilsService,
	) {}

	get_all_callers_times(from_date, to_date) {
		const url = `${environment.api}call_report/get_all_caller_times`;
		const formData: any = this.utils.jsonToFormData({ from_date: from_date, to_date: to_date });
		return this.http.post(url, formData);
	}

		getTalkByCampaign(from_date, to_date) {
		const url = `${environment.api}call_report/get_talk_by_campaign`;
		const formData: any = this.utils.jsonToFormData({ from_date: from_date, to_date: to_date });
		return this.http.post(url, formData);
	}

}
